import { useEffect, useState } from "react";
import api from "@/lib/api";
import StatusBadge from "@/components/common/StatusBadge";
import { Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";

export default function Sessions() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    setBusy(true);
    const params = new URLSearchParams();
    if (status) params.set("status", status);
    const { data } = await api.get(`/api/admin/sessions?${params.toString()}`);
    setItems(data); setBusy(false);
  };
  useEffect(() => { load(); }, [status]);

  const terminate = async (s) => {
    await api.post(`/api/admin/sessions/${s.session_id}/terminate`);
    toast.success("Session terminated");
    load();
  };

  return (
    <div className="space-y-6" data-testid="sessions-page">
      <div className="flex items-center justify-between">
        <div className="text-[var(--text-2)] text-sm">JWT-backed launch sessions. Tokens expire after 2h.</div>
        <select value={status} onChange={(e) => setStatus(e.target.value)}
                className="px-3 py-2 bg-[var(--surface)] border border-[var(--border)] rounded text-sm" data-testid="session-status-filter">
          <option value="">All</option><option value="active">Active</option><option value="expired">Expired</option><option value="terminated">Terminated</option>
        </select>
      </div>
      <div className="card-surface overflow-hidden">
        <div className="overflow-x-auto max-h-[70vh]">
          <table className="aggr-table">
            <thead><tr><th>Session ID</th><th>Operator</th><th>Player</th><th>Game</th><th>Currency</th><th>Status</th><th>Expires</th><th></th></tr></thead>
            <tbody>
              {busy && <tr><td colSpan={8} className="text-center py-6"><Loader2 className="inline animate-spin" size={14}/></td></tr>}
              {!busy && items.length === 0 && <tr><td colSpan={8} className="text-center text-[var(--text-3)] py-8">No sessions yet. Launch a game from Sandbox.</td></tr>}
              {!busy && items.map(s => (
                <tr key={s.session_id}>
                  <td className="font-mono text-xs">{s.session_id}</td>
                  <td className="font-mono text-xs">{s.operator_id}</td>
                  <td className="font-mono text-xs">{s.player_id}</td>
                  <td className="font-mono text-xs">{s.game_id}</td>
                  <td className="font-mono text-xs">{s.currency}</td>
                  <td><StatusBadge status={s.status}/></td>
                  <td className="font-mono text-xs text-[var(--text-3)]">{new Date(s.expires_at).toLocaleString()}</td>
                  <td>{s.status === "active" && (
                    <button onClick={() => terminate(s)} className="btn-ghost px-2 py-1 rounded text-xs flex items-center gap-1" data-testid={`terminate-${s.session_id}`}>
                      <XCircle size={11}/> End
                    </button>
                  )}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
